import firebase from "firebase";
import Logger from "./Logger";
import Settings from "./Settings";

const logger = new Logger("firebase-connector");
//Example guid
// const guid = "upsra-web";

const Methods = {
	HEAD: "HEAD",
	GET: "GET",
	POST: "POST",
	PUT: "PUT",
	PATCH: "PATCH",
	DELETE: "DELETE"
};

//Change acordingly to app needs
const config = {
	projectId: Settings.PROJECT_ID,
	apiKey: Settings.API_KEY,
	authDomain: Settings.AUTH_DOMAIN,
	databaseURL: Settings.DATABASE_URL,
	storageBucket: Settings.STORAGE_BUCKET,
	messagingSenderId: Settings.MESSAGING_SENDER_ID
};
firebase.initializeApp(config);
const db = firebase.database();

export default class FirebaseConnector {
	constructor(options = {}) {
		// uow = guid
		const { apikey = "", timeout = 0, trackingId = "" } = options;

		this._defaultHeaders = {};
		if (apikey) this._defaultHeaders["X-ApiKey"] = apikey;
		if (trackingId) this._defaultHeaders["X-TrackingId"] = trackingId;

		if (timeout) this._timeout = timeout;

		/*
		logger.info(
			`FirebaseConnector instance created for: ${uow} ${apikey} ${trackingId}`
		);
		*/
	}
	init(config) {
		firebase.initializeApp(config);
	}
	get(uri, id, callback) {
		let method = Methods.GET;
		if (!uri || uri instanceof String) {
			return logger.error(`No valid uri given for method ${method}`) && this;
		}

		return new Promise((resolve, reject) => {
			db.ref(id ? uri + "/" + id : uri).once("value", snapshot => {
				let snap = snapshot.val();
				resolve(snap);
				if (callback) {
					callback(snap);
				}
			});
		});
	}
	listener(uri, callback) {
		db.ref(uri).on("value", snapshot => {
			let snap = snapshot.val();
			if (callback) {
				callback(snap);
			}
		});
	}
	del(uri, id) {
		db.ref(uri + "/" + id).remove();
	}

	save(uri, obj, id) {
		let newKey;
		if (id) newKey = id;
		else newKey = new Date();
		db.ref(uri + "/" + newKey.valueOf()).set(obj);
	}

	createUserWithEmailAndPass(user, onSuccess, onError) {
		firebase
			.auth()
			.createUserWithEmailAndPassword(user.userName, user.password)
			.then(user => {
				if (onSuccess) {
					onSuccess();
				}
			})
			.catch(error => {
				if (onError) {
					onError(error);
				}
			});
	}
	uploadFile(file, path, type, callback) {
		var progreso = 0;
		var storageRef = firebase.storage().ref();
		let filename = new Date().getTime();
		var metadata = {
			contentType: "image/jpeg"
		};
		var uploadTask = "";
		switch (type) {
			case "image":
				uploadTask = storageRef
					.child(`images/${path}/${filename}.jpg`)
					.put(file, metadata);
				break;
			case "excel":
				uploadTask = storageRef.child(`${path}/${filename}.xlsx`).put(file);
				break;
			case "imageEncode64":
				uploadTask = storageRef
					.child(`images/${path}/${filename}.jpg`)
					.putString(file, "data_url");
				break;
			default:
				break;
		}

		// Register three observers:
		// 1. 'state_changed' observer, called any time the state changes
		// 2. Error observer, called on failure
		// 3. Completion observer, called on successful completion
		uploadTask.on(
			"state_changed",
			function(snapshot) {
				// Observe state change events such as progress, pause, and resume
				// Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
				progreso = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				// console.log(progreso, " %");
				switch (snapshot.state) {
					case firebase.storage.TaskState.PAUSED: // or 'paused'
						// console.log("Upload is paused");
						break;
					case firebase.storage.TaskState.RUNNING: // or 'running'
						// console.log("Upload is running");
						break;
					default:
						break;
				}
			},
			function(error) {
				// Handle unsuccessful uploads
				console.log("Has been occurred an error.");
			},
			function() {
				// Handle successful uploads on complete
				// For instance, get the download URL: https://firebasestorage.googleapis.com/...
				// var downloadURL = uploadTask.snapshot.getDownloadURL;
				// console.log("downloadURL", downloadURL);
				// var downloadURL = uploadTask.snapshot.downloadURL;
				// console.log("downloadURL2", downloadURL);
				if (progreso === 100) {
					firebase
						.storage()
						.ref()
						.child(`images/${path}/${filename}.jpg`)
						.getDownloadURL()
						.then(function(url) {
							let pathfinal = `images/${path}/${filename}.jpg`;
							// console.log("get the URL", url);
							// console.log("get the Path", pathfinal);
							callback(url, pathfinal);
							// return url;
						});
				}
			}
		);
	}
	deleteImage(path, callback) {
		var storageRef = firebase.storage().ref();
		let deleteRef = storageRef.child(path);
		// Delete the file
		deleteRef
			.delete()
			.then(function(respDelete) {
				// File deleted successfully
				callback();
			})
			.catch(function(error) {
				// Uh-oh, an error occurred!
			});
	}
	post(uri, args = {}) {
		return this._request(uri, { ...args, method: Methods.POST });
	}

	put(uri, obj) {
		db.ref(uri + "/" + obj.ref).update(obj);
	}

	login(user, pass) {
		return new Promise(async (resolve, reject) => {
			try {
				let auth = firebase.auth();
				let resp = auth.signInWithEmailAndPassword(user, pass);
				resolve(resp);
			} catch (error) {
				reject(error);
			}
		});
	}

	// used in the login process
	getToken() {
		return new Promise(async (resolve, reject) => {
			try {
				let resp = firebase.auth().currentUser.getIdToken(true);
				resolve(resp);
			} catch (error) {
				reject(error);
			}
		});
	}

	forgotPassword(email) {
		return new Promise(async (resolve, reject) => {
			try {
				let auth = firebase.auth();
				let resp = auth.sendPasswordResetEmail(email, null);
				resolve(resp);
			} catch (error) {
				reject(error);
			}
		});
	}

	confirmPasswordReset(code, password) {
		return new Promise(async (resolve, reject) => {
			try {
				let auth = firebase.auth();
				let resp = auth.confirmPasswordReset(code, password);
				resolve(resp);
			} catch (error) {
				reject(error);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/provider/base/FirebaseConnector.js